module.exports = __webpack_public_path__ + "img/software_icon2.5a891cad.png";